export default "__VITE_ASSET__D9bL9BXZ__"